__turbopack_context__.v({
  "button": "mX17bW_button",
  "card": "mX17bW_card",
  "container": "mX17bW_container",
  "error": "mX17bW_error",
  "footer": "mX17bW_footer",
  "footerText": "mX17bW_footerText",
  "form": "mX17bW_form",
  "formGroup": "mX17bW_formGroup",
  "header": "mX17bW_header",
  "hint": "mX17bW_hint",
  "input": "mX17bW_input",
  "label": "mX17bW_label",
  "link": "mX17bW_link",
  "logo": "mX17bW_logo",
  "logoMark": "mX17bW_logoMark",
  "subtitle": "mX17bW_subtitle",
  "title": "mX17bW_title",
});
